import {ExperimentNames, hasImage} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../../../../hooks/use-visibility-styles'
import {getSelectedEventId} from '../../../../../../../selectors/calendar-layout'
import {getEventBadge, getEventById} from '../../../../../../../selectors/events'
import {EventBadge} from '../../../../../../event-badge'
import {EventImage} from '../../../../../../event-image'
import {RsvpButton} from '../../../../../../rsvp-button'
import {EventDetailsContent} from '../content'
import s from './vertical-layout.scss'

export const VerticalEventDetailsLayout = () => {
  const {
    allBreakpoints: {isEventBadgeOnImage},
  } = useVisibilityStyles()
  const {experiments} = useExperiments()

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const event = useWidgetState(state => getEventById(state, selectedEventId))
  const eventBadge = useWidgetState(state => getEventBadge(state, event))

  return (
    <>
      <div className={classNames(s.content, {[s.old]: !calendarRevampEnabled})}>
        {hasImage(event) && (
          <div aria-hidden className={classNames(s.image, {[s.calendarRevamp]: calendarRevampEnabled})}>
            <EventImage noLQIP calendarLayout event={event} />
            {isEventBadgeOnImage(eventBadge?.type, calendarRevampEnabled) && <EventBadge onImage event={event} />}
          </div>
        )}
        <EventDetailsContent />
      </div>
      <RsvpButton
        calendar={calendarRevampEnabled}
        dataHook="rsvp-button"
        event={event}
        minWidth={88}
        minHeight={32}
        containerClassName={calendarRevampEnabled ? s.rsvpButton : s.button}
      />
    </>
  )
}
